import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const RevealStagger = ({ children, className = "", stagger = 0.09 }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 30 }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] },
      },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

// Word-by-word "cascading" heading reveal. Wrap accent words in {curly braces}.
export const Cascade = ({ text, className = "" }) => {
  const segments = [];
  const re = /\{([^}]+)\}|([^{]+)/g;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m[1] !== undefined) segments.push({ t: m[1], accent: true });
    else if (m[2] !== undefined) segments.push({ t: m[2], accent: false });
  }
  const words = [];
  segments.forEach((seg) => {
    seg.t.split(/(\s+)/).forEach((w) => {
      if (w.length === 0) return;
      words.push({ w, accent: seg.accent });
    });
  });

  return (
    <motion.span
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-70px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.05 } } }}
    >
      {words.map((it, i) =>
        /^\s+$/.test(it.w) ? (
          <span key={i}>{"\u00A0"}</span>
        ) : (
          <motion.span
            key={i}
            className={`inline-block ${it.accent ? "text-orange" : ""}`}
            variants={{
              hidden: { y: "-0.45em", opacity: 0, rotate: -3, filter: "blur(4px)" },
              show: {
                y: 0,
                opacity: 1,
                rotate: 0,
                filter: "blur(0px)",
                transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
              },
            }}
          >
            {it.w}
          </motion.span>
        )
      )}
    </motion.span>
  );
};
